<script lang="ts">
import Vue from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'
import {groupBy, sortBy, capitalize} from 'lodash'

import api from '@/api'
import {ApexOptions} from 'apexcharts'

@Component({})
export default class SpaceChartMotionTrend extends Vue {
  @Prop()
  spaceId: string

  interval: string = '90d'

  daysOfWeek = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY']
  eventTypes = ['MOTION_COUNT_HISTORICAL', 'MOTION_COUNT_CURRENT']

  promise: Promise<any> = null
  events: any[] = []

  get eventTypesLabels() {
    return {
      MOTION_COUNT_HISTORICAL: `Historical Average (last ${this.interval})`,
      MOTION_COUNT_CURRENT: 'Current Week since Monday',
    }
  }

  get chartOptions(): ApexOptions {
    return {
      chart: {
        type: 'bar',
      },
      xaxis: {
        categories: this.daysOfWeek,
        labels: {
          formatter: (val) => capitalize(val),
        },
      },
      yaxis: [
        {
          title: {
            text: 'Average Motion Count',
          },
          labels: {
            formatter(val: number) {
              return val.toFixed(0)
            },
          },
        },
      ],
      plotOptions: {
        bar: {
          borderRadius: 5,
          horizontal: false,
        },
      },
      legend: {
        showForSingleSeries: true,
      },
      stroke: {
        width: 2,
      },
    }
  }

  get series(): any[] {
    /**
     * [{
     * uid: "1B31WA000083",
     * deviceType: "ORIGIN_BOT",
     * eventType: "MOTION_COUNT_CURRENT" | "MOTION_COUNT_HISTORICAL",
     * locationId: "300",
     * locationName: "Bedroom",
     * value: 202,
     * dayOfWeek: "MONDAY"
     * }]
     */

    let grouped = groupBy(this.events, 'eventType')
    let ret = []
    // console.log('grouped1', grouped)

    this.eventTypes.map((eventType) => {
      let subGroup = groupBy(grouped[eventType], 'dayOfWeek')
      // console.log('grouped2', subGroup)
      let subGroupData = []

      this.daysOfWeek.map((day) => {
        subGroup[day] = subGroup[day] || []
        subGroupData.push(subGroup[day].reduce((total, event) => total + event.value, 0))
      })

      ret.push({
        name: this.eventTypesLabels[eventType],
        data: subGroupData,
      })
    })

    // console.log('ret', ret)
    return ret
  }

  setTimeframe(interval: string) {
    this.events = []
    this.interval = interval

    this.promise = api.spaces
      .chartRoomMotionTrend(this.spaceId, {
        interval: interval,
      })
      .then((resp) => {
        this.events = resp.data.events
      })
  }

  mounted() {
    this.setTimeframe(this.interval)
  }
}
</script>
|
<template>
  <div>
    <h4 class="mt-5 mb-3">
      Current vs Historic motion activity ({{ interval }})

      <span class="small">
        <b-link @click="setTimeframe('30d', 'DAY')" class="ml-1 small">Month</b-link> &centerdot;
        <b-link @click="setTimeframe('90d', 'DAY')" class="ml-1 small">3 Months</b-link> &centerdot;
        <b-link @click="setTimeframe('365d', 'DAY')" class="ml-1 small">1 Year</b-link>
      </span>
    </h4>

    <div class="row mt-4">
      <div class="col">
        <div class="card card-body">
          <promised :promise="promise" :pending-delay="0">
            <template #pending>
              <div class="spinner-border mx-auto" role="status"></div>
            </template>
            <template #rejected>
              <div class="card-subtitle text-danger mt-2">Error loading data</div>
            </template>
            <template>
              <div v-if="events.length">
                <div>
                  <apexchart
                    v-if="events"
                    height="400"
                    :options="chartOptions"
                    :series="series"></apexchart>
                </div>
              </div>
              <div v-else>
                <div class="card-subtitle text-muted mt-2">No data</div>
              </div>
            </template>
          </promised>
        </div>
      </div>
    </div>
  </div>
</template>
